<template>
  <div 
    class="mt-5">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div 
                        class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.freeze">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.freeze ? 'font-weight-bold' : ''"
                                :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.hide = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in headers" 
                            :key="index"
                            class="px-0"
                            @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.hide">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.hide ? 'font-weight-bold' : ''"
                                :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Filter Data
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.filter = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <div>
                
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn 
                @click="dialog.filter = false; fetch();"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Filter
              </v-btn>

              <v-btn 
                @click="dialog.filter = false"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- <v-dialog v-model="dialog.detail"
          @keydown.esc="dialog.detail = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Detail Perusahaan

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.detail = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0" v-if="Object">
              <v-form>
                <v-row>
                  <v-col cols="6">
                    
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.detail = false; dialog.fullscreen = false; ">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
        
        <section>
          <!-- <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Pegawai
                    </span>
                  </div>

                  <v-spacer />

                  <div>
                    <v-btn
                      to="/user/add"
                      color="#4B4B4B"
                      elevation="0"
                      class="body-2 white--text text-capitalize d-flex align-center"
                      style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                      <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                      
                      <span
                        class="ml-2">
                        Tambah
                      </span>
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row> -->
          <div style="">
              <v-card
                flat
                class="mt-2"
                color="transparent">
                <div
                  class="d-flex align-center px-3">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="22">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>
    
                    <span
                      class="fs-16 black--text ml-2"
                      style="font-weight: 600;">
                      Laba Rugi
                    </span>
                  </div>
    
                  <v-spacer />
    
                </div>
              </v-card>
              
              <div class="d-flex mt-3 px-4">
                <!-- <div>
                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :return-value.sync="filter.date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="filter.date"
                        :color="set_color"
                        placeholder="Pilihan periode"
                        prepend-inner-icon="mdi-calendar"
                        hide-details
                        readonly
                        filled
                        rounded
                        clearable
                        dense
                        v-bind="attrs"
                        v-on="on"
                        style="border-radius: 10px;"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.date"
                      no-title
                      scrollable
                      type="month"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu2 = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu2.save(filter.date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div> -->
                <div class="d-flex align-center" style="">
                  <!-- <v-select
                    filled
                    rounded
                    dense
                    hide-details
    
                    :color="set_color"
                    placeholder="Contoh. 2023"
    
                    :items="years"
                    :item-color="set_color"
                    class="fs-12 little-placeholder"
    
                    v-model="filter.year"
                    style="border-radius: 10px; width: 200px; max-width: 200px;">
                  </v-select> -->
                  <div>
        
                    <v-menu
                      ref="range"
                      min-width="290px"
                      max-width="290px"
                      transition="scale-transition"
                      offset-y
                      :nudge-right="40"
                      :close-on-content-click="false"
                      v-model="picker.month">
                      <template v-slot:activator="{ on, attrs }">
                        <!-- <v-text-field
                          readonly
                          filled
                          rounded
                          dense
                          single-line
                          :color="set_color"
                          placeholder="Contoh. 2023-01-01 s/d 2023-12-01"
    
                          hide-details
    
                          v-on="on"
                          v-bind="attrs"
    
                          v-model="date_range"
                          class="mb-2"
                          style="border-radius: 10px !important;">
                        </v-text-field> -->
    
                        <v-card
                          v-on="on"
                          v-bind="attrs"
    
                          flat
                          color="#f2f2f2"
                          class="mb-0"
                          style="border-radius: 6px; width: 150px; min-width: 150px; max-width: 150px;">
                          <div
                            class="d-flex align-center"
                            style="padding: 9px;">
                            <!-- <v-icon>mdi-calendar-multiselect-outline</v-icon> -->
    
                            <div
                              class="fs-13 ml-1">
                              <!-- {{ filter.dates[0] | date_month }} - {{ filter.dates[1] | fulldate }} -->
                              {{ filter.month | month_year }}
                            </div>
                          </div>
                        </v-card>
                      </template>
                      
                      <v-date-picker 
                        type="month"
                        :color="set_color"
                        v-model="filter.month"
                        @input="picker.month = filter.month.length > 1 ? false : true; fetch();">
                      </v-date-picker>
                    </v-menu>
                  </div>
                  <div class="ml-auto d-flex" v-if="!process.load">
                    <div>
                      <div style="" class="text-right px-4 pl-2 d-flex align-center">
                        <div class="black_one font_weight_600 fs-12">
                          Laba Rugi: 
                        </div>
                        <div class="font_weight_600 fs-15 ml-2" :class="'black_one'">
                          {{ laba_rugi | price }}
                        </div>
                      </div>
                    </div>
                    <!-- <div>
                      <div style="" class="text-right px-4 pl-2 d-flex align-center">
                        <div class="black_one fs-12 font_weight_600">
                          Total Pendapatan: 
                        </div>
                        <div class="font_weight_600 fs-15 ml-2" :class="'black_one'">
                          {{( total_pendapatan - list_pendapatan_lain[0].saldo) | price }}
                        </div>
                      </div>
                    </div>
                    <div>
                      <div style="" class="text-right px-4 pl-2 d-flex align-center">
                        <div class="black_one font_weight_600 fs-12">
                          Total Biaya: 
                        </div>
                        <div class="font_weight_600 fs-15 ml-2" :class="'black_one'">
                          {{ (total_biaya - list_hpp[0].saldo - list_biaya_lain[0].saldo ) | price }}
                        </div>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
              <v-card-text
                v-if="process.load" 
                class="pb-0 my-4" 
                style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center; border: 1px solid #ededed;">
                <div class="text-center">
                  <div class="mb-4 title">
                    Mohon Tunggu . . .
                  </div>

                  <v-progress-linear
                    :color="set_color"
                    indeterminate
                    rounded
                    height="10">
                  </v-progress-linear>
                </div>
              </v-card-text>
              <v-card-text style="width: fit-content" v-if="!process.load">
                <div style="">
                  <table>
                    <tr>
                      <td colspan="5" class="font-weight-bold white--text" style="background: #080679; font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: left;">Pendapatan</td>
                    </tr>
                    <tr v-for="(item, index) in list_pendapatan" :key="index">
                      <td :class="item.have_child ? 'font_weight_600' : ''" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: left;">{{ item.name }}</td>
                      <td :class="item.have_child ? 'font_weight_600' : ''" class="pr-2" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: right;">
                        <span v-if="item.array === 4">{{ item.number }}</span>
                      </td>
                      <td :class="item.have_child ? 'font_weight_600' : ''" class="pr-2" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: right;">
                        <span v-if="item.array === 3">{{ item.saldo | price }}</span>
                      </td>
                      <td :class="item.have_child ? 'font_weight_600' : ''" class="pr-2" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: right;">
                        <span v-if="item.array === 2">{{ item.saldo | price }}</span>
                      </td>
                      <td :class="item.have_child ? 'font_weight_600' : ''" class="pr-2" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: right;">
                        <span v-if="item.array === 1">{{ item.saldo | price }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4" class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: left;">Jumlah Pendapatan</td>
                      <td class="pr-2 font-weight-bold" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: right;">{{ total_pendapatan | price }}</td>
                    </tr>
                    <!-- <tr>
                      <td colspan="5" class="font-weight-bold white--text" style="background: #080679; font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: left;">Biaya</td>
                    </tr> -->

                    <tr>
                      <td colspan="5" class="font-weight-bold white--text" style="background: #080679; font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: left;">Hpp</td>
                    </tr>
                    <tr v-for="(item, index) in list_hpp" :key="index">
                      <td :class="item.have_child ? 'font_weight_600' : ''" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: left;">{{ item.name }}</td>
                      <td :class="item.have_child ? 'font_weight_600' : ''" class="pr-2" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: right;">
                        <span v-if="item.array === 4">{{ item.number }}</span>
                      </td>
                      <td :class="item.have_child ? 'font_weight_600' : ''" class="pr-2" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: right;">
                        <span v-if="item.array === 3">{{ item.saldo | price }}</span>
                      </td>
                      <td :class="item.have_child ? 'font_weight_600' : ''" class="pr-2" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: right;">
                        <span v-if="item.array === 2">{{ item.saldo | price }}</span>
                      </td>
                      <td :class="item.have_child ? 'font_weight_600' : ''" class="pr-2" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: right;">
                        <span v-if="item.array === 1">{{ item.saldo | price }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4" class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: left;">Jumlah Hpp</td>
                      <td class="pr-2 font-weight-bold" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: right;">{{ list_hpp[0].saldo | price }}</td>
                    </tr>

                    <tr>
                      <td colspan="5" class="font-weight-bold white--text" style="background: #080679; font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: left;">Biaya</td>
                    </tr>

                    <tr v-for="(item, index) in list_biaya" :key="index">
                      <td :class="item.have_child ? 'font_weight_600' : ''" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: left;">{{ item.name }}</td>
                      <td :class="item.have_child ? 'font_weight_600' : ''" class="pr-2" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: right;">
                        <span v-if="item.array === 4">{{ item.number }}</span>
                      </td>
                      <td :class="item.have_child ? 'font_weight_600' : ''" class="pr-2" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: right;">
                        <span v-if="item.array === 3">{{ item.saldo | price }}</span>
                      </td>
                      <td :class="item.have_child ? 'font_weight_600' : ''" class="pr-2" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: right;">
                        <span v-if="item.array === 2">{{ item.saldo | price }}</span>
                      </td>
                      <td :class="item.have_child ? 'font_weight_600' : ''" class="pr-2" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: right;">
                        <span v-if="item.array === 1">{{ item.saldo | price }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4" class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: left;">Jumlah Biaya</td>
                      <td class="pr-2 font-weight-bold" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: right;">{{ total_biaya | price }}</td>
                    </tr>

                    <tr>
                      <td colspan="5" class="font-weight-bold white--text" style="background: #080679; font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: left;">Pendapatan Lain - lain</td>
                    </tr>
                    <tr v-for="(item, index) in list_pendapatan_lain" :key="index">
                      <td :class="item.have_child ? 'font_weight_600' : ''" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: left;">{{ item.name }}</td>
                      <td :class="item.have_child ? 'font_weight_600' : ''" class="pr-2" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: right;">
                        <span v-if="item.array === 4">{{ item.number }}</span>
                      </td>
                      <td :class="item.have_child ? 'font_weight_600' : ''" class="pr-2" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: right;">
                        <span v-if="item.array === 3">{{ item.saldo | price }}</span>
                      </td>
                      <td :class="item.have_child ? 'font_weight_600' : ''" class="pr-2" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: right;">
                        <span v-if="item.array === 2">{{ item.saldo | price }}</span>
                      </td>
                      <td :class="item.have_child ? 'font_weight_600' : ''" class="pr-2" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: right;">
                        <span v-if="item.array === 1">{{ item.saldo | price }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4" class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: left;">Jumlah Pendapatan Lain - lain</td>
                      <td class="pr-2 font-weight-bold" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: right;">{{ list_pendapatan_lain[0].saldo | price }}</td>
                    </tr>

                    <tr>
                      <td colspan="5" class="font-weight-bold white--text" style="background: #080679; font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: left;">Biaya Lain - lain</td>
                    </tr>
                    <tr v-for="(item, index) in list_biaya_lain" :key="index">
                      <td :class="item.have_child ? 'font_weight_600' : ''" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: left;">{{ item.name }}</td>
                      <td :class="item.have_child ? 'font_weight_600' : ''" class="pr-2" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: right;">
                        <span v-if="item.array === 4">{{ item.number }}</span>
                      </td>
                      <td :class="item.have_child ? 'font_weight_600' : ''" class="pr-2" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: right;">
                        <span v-if="item.array === 3">{{ item.saldo | price }}</span>
                      </td>
                      <td :class="item.have_child ? 'font_weight_600' : ''" class="pr-2" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: right;">
                        <span v-if="item.array === 2">{{ item.saldo | price }}</span>
                      </td>
                      <td :class="item.have_child ? 'font_weight_600' : ''" class="pr-2" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: right;">
                        <span v-if="item.array === 1">{{ item.saldo | price }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4" class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: left;">Jumlah Pendapatan Lain - lain</td>
                      <td class="pr-2 font-weight-bold" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 150px; white-space: nowrap; text-align: right;">{{ list_biaya_lain[0].saldo | price }}</td>
                    </tr>
                  </table>
                </div>
              </v-card-text>
            </div>

        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,
        selected_data: '',
        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          delete: false,
          reset: false,
          role: false,

          filter: false,
          form: false,
        },
        laba_rugi: 0,
        
        search: '',
        picker: {
          range: false,

          start_date: false,
          end_date: false,
          month: false
        },

        menu2: false,
        filter: {
          date: '',
          year: new Date().getFullYear(),

          month: moment().format('YYYY-MM'),
          month_text: 'Januari',
        },

        selected: {
          row: [],
          freeze: [],
          delete: [],
          reset: [],
          role: [],
          activa: '',
          biaya: ''
        },

        role: [],

        options: {},
        headers: [],
        list: [],
        list_pendapatan: [],
        list_biaya: [],
        list_hpp: [],
        list_pendapatan_lain: [],
        list_biaya_lain: [],
        pagination: {},
        total_pendapatan: 0,
        total_biaya: 0,

        lastIndex: 0,
        limit: 20,

        form: {
          month: moment().format('YYYY-MM'),
          position: '',
          biaya_array: [],
          pendapatan_array: []
        },

        process: {
          load: false,

          delete: false,
          reset: false,
          role: false,
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      'filter.year': function () {
        this.fetch()
      },

      'filter.month': function () {
        let t = this

        let m = this.months.filter(function(v) {
          return t.filter.month == v.value
        })

        if (m.length > 0) {
          this.filter.month_text = m[0].text
        }
        this.fetch()
      },
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          
          this.fetch(pagination)
        },
        deep: true
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      years () {
        let max = new Date().getFullYear()+4, min = max - 8, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      },
      months () {
        let numb = new Date().getMonth() + 1
        

        return [
          {
            text: 'Januari',
            value: 1
          },
          {
            text: 'Februari',
            value: 2
          },
          {
            text: 'Maret',
            value: 3
          },
          {
            text: 'April',
            value: 4
          },
          {
            text: 'Mei',
            value: 5
          },
          {
            text: 'Juni',
            value: 6
          },
          {
            text: 'Juli',
            value: 7
          },
          {
            text: 'Agustus',
            value: 8
          },
          {
            text: 'September',
            value: 9
          },
          {
            text: 'Oktober',
            value: 10
          },
          {
            text: 'November',
            value: 11
          },
          {
            text: 'Desember',
            value: 12
          }
        ]
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },

      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          // limit: pagination.row,
          // page: pagination.page,
          // sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          // search: this.search
          month: this.filter.month
        }

        this.selected.row = []

        await get(`lostprofit/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          this.list_pendapatan = []
          this.list_biaya = []
          this.pagination = {}
            
          if (res.status === 200) {
            this.headers = [
              // {
              //   text: 'Aksi',
              //   width: '120px',
              //   value: 'id',
              //   freeze: true,
              //   hide: false,
              //   align: 'center',
              //   format: 'action'
              // },
              // {
              //   text: 'Nomor Induk Pegawai',
              //   width: '200px',
              //   value: 'nip',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Nama',
                width: '100%',
                value: 'name',
                freeze: false,
                hide: false
              }
            ]
            let pendapatan_1 = [], pendapatan_2 = [], pendapatan_3 = [], pendapatan_4 = [], biaya_1 = [], biaya_2 = [], biaya_3 = [], biaya_4 = []
            this.list_pendapatan = []
            this.list_biaya = []
            this.pagination = {}
              
            if (res.status === 200) {
              res.results.data.pendapatan_array.map((item, index) => {
                pendapatan_1.push({
                  ...item,
                  array: 1,
                  have_child: item.child.length > 0 ? true : false
                })
                item.child.map((c1, i1) => {
                  pendapatan_2.push({
                    ...c1,
                    array: 2,
                    have_child: c1.child.length > 0 ? true : false
                  })
                  c1.child.map((c2, i2) => {
                    pendapatan_3.push({
                      ...c2,
                      array: 3,
                      have_child: c2.child.length > 0 ? true : false
                    })
                    c2.child.map((c3, i3) => {
                      pendapatan_4.push({
                        ...c3,
                        array: 4,
                        have_child: c3.child.length > 0 ? true : false
                      })
                      pendapatan_3[i2].child = pendapatan_4
                    })
                    pendapatan_2[i1].child = pendapatan_3
                  })
                  pendapatan_1[index].child = pendapatan_2
                })

              })

              res.results.data.biaya_array.map((item, index) => {
                biaya_1.push({
                  ...item,
                  array: 1,
                  have_child: item.child.length > 0 ? true : false
                })
                item.child.map((c1, i1) => {
                  biaya_2.push({
                    ...c1,
                    array: 2,
                    have_child: c1.child.length > 0 ? true : false
                  })
                  c1.child.map((c2, i2) => {
                    biaya_3.push({
                      ...c2,
                      array: 3,
                      have_child: c2.child.length > 0 ? true : false
                    })
                    c2.child.map((c3, i3) => {
                      biaya_4.push({
                        ...c3,
                        array: 4,
                        have_child: c3.child.length > 0 ? true : false
                      })
                      biaya_3[i2].child = biaya_4
                    })
                    biaya_2[i1].child = biaya_3
                  })
                  biaya_1[index].child = biaya_2
                })

              })

              // res.results.data.pendapatan_array.map((item, index) => {
              //   this.list_pendapatan.push(item)
              // })
              // res.results.data.biaya_array.map((item, index) => {
              //   this.list_biaya.push(item)
              // })

              const flatten = (array) => array.flatMap(({id, name, number, saldo, array, have_child, child}) => [
                { id, name, number, saldo, array, have_child },
                ...flatten(child || [])
              ]);
              // this.list_pendapatan = flatten(pendapatan_1);
              // this.list_biaya = flatten(biaya_1);
              this.total_pendapatan = res.results.data.total_pendapatan*1
              this.total_biaya = res.results.data.total_biaya*1
              this.laba_rugi = res.results.data.laba_rugi*1
              this.list_pendapatan = []
              this.list_hpp = []
              this.list_pendapatan_lain = []
              this.list_biaya = []
              this.list_biaya_lain = []


              res.results.data.pendapatan_array.map((item, index_par) => {
                if(item.id !== '281') {
                  this.list_pendapatan.push({
                    ...item,
                    array: 1,
                    have_child: item.child.length > 0 ? true : false
                  })
                  if(item.child.length > 0){
                    item.child.map((child, index) => {
                      if(child.child.length > 0){
                        child.child.map((child2, index2) => {
                          this.list_pendapatan.push(
                            {
                              ...child,
                              array: 2,
                              have_child: true
                            }
                          )
                          // this.list_pendapatan.push(
                          //   {
                          //     ...child2,
                          //     array: 2,
                          //     have_child: false
                          //   }
                          // )
                          if(child2.child.length > 0){
                            child2.child.map((child3, index3) => {
                              this.list_pendapatan.push(
                                {
                                  ...child2,
                                  array: 3,
                                  have_child: true
                                }
                              )
                              this.list_pendapatan.push(
                                {
                                  ...child3,
                                  array: 4,
                                  have_child: false
                                }
                              )
                            })
                          } else {
                            this.list_pendapatan.push(
                              {
                                ...child2,
                                array: 3,
                                have_child: false
                              }
                            )
                          }
                        })
                      } else {
                        this.list_pendapatan.push(
                          {
                            ...child,
                            array: 2,
                            have_child: false
                          }
                        )
                      }
                    }
                    )
                    // item.child.map((child, index) => {
                    //   this.list.push(
                    //     {
                    //       ...child,
                    //       num_children: 1,
                    //       no: index === 0 ? 'a' : index === 1 ? 'b' : index === 2 ? 'c' : index === 3 ? 'd' : index === 4 ? 'e' : index === 5 ? 'f' : index === 6 ? 'g' : index === 7 ? 'h' : index === 8 ? 'i' : index === 9 ? 'j' : index === 10 ? 'k' : index === 11 ? 'l' : index === 12 ? 'm' : index === 13 ? 'n' : index === 14 ? 'o' : index === 15 ? 'p' : index === 16 ? 'q' : index === 17 ? 'r' : index === 18 ? 's' : index === 19 ? 't' : index === 20 ? 'u' : index === 21 ? 'v' : index === 22 ? 'w' : index === 23 ? 'x' : index === 24 ? 'y' : index === 25 ? 'z' : index === 26 ? 'aa' : index === 27 ? 'ab' : index === 28 ? 'ac' : index === 29 ? 'ad' : index === 30 ? 'ae' : index === 31 ? 'af' : index === 32 ? 'ag' : index === 33 ? 'ah' : index === 34 ? 'ai' : index === 35 ? 'aj' : index === 36 ? 'ak' : index === 37 ? 'al' : index === 38 ? 'am' : index === 39 ? 'an' : index === 40 ? 'ao' : index === 41 ? 'ap' : index === 42 ? 'aq' : index === 43 ? 'ar' : index === 44 ? 'as' : index === 45 ? 'at' : index === 46 ? 'au' : index === 47 ? 'av' : index === 48 ? 'aw' : index === 49 ? 'ax' : index === 50 ? 'ay' : index === 51 ? 'az' : index === 52 ? 'ba' : index === 53 ? 'bb' : index === 54 ? 'bc' : index === 55 ? 'bd' : index === 56 ? 'be' : ''
                    //     }
                    //   )
                    // })
                    // item.child.map(child => {
                    //   if(child.child.length > 0){
                    //     child.child.map((child2, index2) => {
                    //       this.list.push(
                    //         {
                    //           ...child2,
                    //           num_children: 2,
                    //           no: index2 + 1
                    //         }
                    //       )
                    //     })
                    //   }
                    // })
                  }
                }

                if(item.id === '281') {
                  this.list_pendapatan_lain.push({
                    ...item,
                    array: 1,
                    have_child: item.child.length > 0 ? true : false
                  })
                  if(item.child.length > 0){
                    item.child.map((child, index) => {
                      if(child.child.length > 0){
                        child.child.map((child2, index2) => {
                          this.list_pendapatan_lain.push(
                            {
                              ...child,
                              array: 2,
                              have_child: true
                            }
                          )
                          // this.list_pendapatan_lain.push(
                          //   {
                          //     ...child2,
                          //     array: 2,
                          //     have_child: false
                          //   }
                          // )
                          if(child2.child.length > 0){
                            child2.child.map((child3, index3) => {
                              this.list_pendapatan_lain.push(
                                {
                                  ...child2,
                                  array: 3,
                                  have_child: true
                                }
                              )
                              this.list_pendapatan_lain.push(
                                {
                                  ...child3,
                                  array: 4,
                                  have_child: false
                                }
                              )
                            })
                          } else {
                            this.list_pendapatan_lain.push(
                              {
                                ...child2,
                                array: 3,
                                have_child: false
                              }
                            )
                          }
                        })
                      } else {
                        this.list_pendapatan_lain.push(
                          {
                            ...child,
                            array: 2,
                            have_child: false
                          }
                        )
                      }
                    }
                    )
                    // item.child.map((child, index) => {
                    //   this.list.push(
                    //     {
                    //       ...child,
                    //       num_children: 1,
                    //       no: index === 0 ? 'a' : index === 1 ? 'b' : index === 2 ? 'c' : index === 3 ? 'd' : index === 4 ? 'e' : index === 5 ? 'f' : index === 6 ? 'g' : index === 7 ? 'h' : index === 8 ? 'i' : index === 9 ? 'j' : index === 10 ? 'k' : index === 11 ? 'l' : index === 12 ? 'm' : index === 13 ? 'n' : index === 14 ? 'o' : index === 15 ? 'p' : index === 16 ? 'q' : index === 17 ? 'r' : index === 18 ? 's' : index === 19 ? 't' : index === 20 ? 'u' : index === 21 ? 'v' : index === 22 ? 'w' : index === 23 ? 'x' : index === 24 ? 'y' : index === 25 ? 'z' : index === 26 ? 'aa' : index === 27 ? 'ab' : index === 28 ? 'ac' : index === 29 ? 'ad' : index === 30 ? 'ae' : index === 31 ? 'af' : index === 32 ? 'ag' : index === 33 ? 'ah' : index === 34 ? 'ai' : index === 35 ? 'aj' : index === 36 ? 'ak' : index === 37 ? 'al' : index === 38 ? 'am' : index === 39 ? 'an' : index === 40 ? 'ao' : index === 41 ? 'ap' : index === 42 ? 'aq' : index === 43 ? 'ar' : index === 44 ? 'as' : index === 45 ? 'at' : index === 46 ? 'au' : index === 47 ? 'av' : index === 48 ? 'aw' : index === 49 ? 'ax' : index === 50 ? 'ay' : index === 51 ? 'az' : index === 52 ? 'ba' : index === 53 ? 'bb' : index === 54 ? 'bc' : index === 55 ? 'bd' : index === 56 ? 'be' : ''
                    //     }
                    //   )
                    // })
                    // item.child.map(child => {
                    //   if(child.child.length > 0){
                    //     child.child.map((child2, index2) => {
                    //       this.list.push(
                    //         {
                    //           ...child2,
                    //           num_children: 2,
                    //           no: index2 + 1
                    //         }
                    //       )
                    //     })
                    //   }
                    // })
                  }
                }
            })


            res.results.data.biaya_array.map((item, index_par) => {
              if(item.id !== '280' && item.id !== '283') {
                this.list_biaya.push({
                  ...item,
                  array: 1,
                  have_child: item.child.length > 0 ? true : false
                })
                if(item.child.length > 0){
                  item.child.map((child, index) => {
                    if(child.child.length > 0){
                      child.child.map((child2, index2) => {
                        this.list_biaya.push(
                          {
                            ...child,
                            array: 2,
                            have_child: true
                          }
                        )
                        // this.list_biaya.push(
                        //   {
                        //     ...child2,
                        //     array: 2,
                        //     have_child: false
                        //   }
                        // )
                        if(child2.child.length > 0){
                          child2.child.map((child3, index3) => {
                            this.list_biaya.push(
                              {
                                ...child2,
                                array: 3,
                                have_child: true
                              }
                            )
                            this.list_biaya.push(
                              {
                                ...child3,
                                array: 4,
                                have_child: false
                              }
                            )
                          })
                        } else {
                          this.list_biaya.push(
                            {
                              ...child2,
                              array: 3,
                              have_child: false
                            }
                          )
                        }
                      })
                    } else {
                      this.list_biaya.push(
                        {
                          ...child,
                          array: 2,
                          have_child: false
                        }
                      )
                    }
                  }
                  )
                }
              }
            })

            res.results.data.biaya_array.map((item, index_par) => {
              if(item.id === '280') {
                this.list_hpp.push({
                  ...item,
                  array: 1,
                  have_child: item.child.length > 0 ? true : false
                })
                if(item.child.length > 0){
                  item.child.map((child, index) => {
                    if(child.child.length > 0){
                      child.child.map((child2, index2) => {
                        this.list_hpp.push(
                          {
                            ...child,
                            array: 2,
                            have_child: true
                          }
                        )
                        // this.list_hpp.push(
                        //   {
                        //     ...child2,
                        //     array: 2,
                        //     have_child: false
                        //   }
                        // )
                        if(child2.child.length > 0){
                          child2.child.map((child3, index3) => {
                            this.list_hpp.push(
                              {
                                ...child2,
                                array: 3,
                                have_child: true
                              }
                            )
                            this.list_hpp.push(
                              {
                                ...child3,
                                array: 4,
                                have_child: false
                              }
                            )
                          })
                        } else {
                          this.list_hpp.push(
                            {
                              ...child2,
                              array: 3,
                              have_child: false
                            }
                          )
                        }
                      })
                    } else {
                      this.list_hpp.push(
                        {
                          ...child,
                          array: 2,
                          have_child: false
                        }
                      )
                    }
                  }
                  )
                }
              }
              if(item.id === '283') {
                this.list_biaya_lain.push({
                  ...item,
                  array: 1,
                  have_child: item.child.length > 0 ? true : false
                })
                if(item.child.length > 0){
                  item.child.map((child, index) => {
                    if(child.child.length > 0){
                      child.child.map((child2, index2) => {
                        this.list_biaya_lain.push(
                          {
                            ...child,
                            array: 2,
                            have_child: true
                          }
                        )
                        // this.list_biaya_lain.push(
                        //   {
                        //     ...child2,
                        //     array: 2,
                        //     have_child: false
                        //   }
                        // )
                        if(child2.child.length > 0){
                          child2.child.map((child3, index3) => {
                            this.list_biaya_lain.push(
                              {
                                ...child2,
                                array: 3,
                                have_child: true
                              }
                            )
                            this.list_biaya_lain.push(
                              {
                                ...child3,
                                array: 4,
                                have_child: false
                              }
                            )
                          })
                        } else {
                          this.list_biaya_lain.push(
                            {
                              ...child2,
                              array: 3,
                              have_child: false
                            }
                          )
                        }
                      })
                    } else {
                      this.list_biaya_lain.push(
                        {
                          ...child,
                          array: 2,
                          have_child: false
                        }
                      )
                    }
                  }
                  )
                }
              }
            })

              // this.list.map((item, index) => {
              //   this.total_pendapatan += (item.balance*1)
              // })

              // this.list_biaya.map((item, index) => {
              //   this.total_biaya += (item.balance*1)
              // })

              // this.list = res.results.data
              // this.pagination = res.results.pagination


              // this.lastIndex = (pagination.page - 1) * pagination.row 
              // this.lastIndex += 1

              // this.addFreezes()

              // this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper-laba-rugi') })

              // if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
            }
          }
        })
      },

      // closeForm() {
      //   this.form.biaya_array = []
      //   this.form.pendapatan_array = []
      //   this.list_pendapatan.map((item, index) => {
      //     this.form.pendapatan_array.push(item)
      //   })

      //   this.list_biaya.map((item, index) => {
      //     this.form.biaya_array.push(item)
      //   })
      // },

      reset () {
        if (this.$refs.form) this.$refs.form.reset()

        this.form.month = moment().format('YYYY-MM')
        this.form.position = ''
        this.message.error = ''
        this.form.biaya_array = []
        this.form.pendapatan_array = []
        this.list_pendapatan.map((item, index) => {
          this.form.pendapatan_array.push(item)
        })

        this.list_biaya.map((item, index) => {
          this.form.biaya_array.push(item)
        })
      },

      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = 'neraca/initial/add'

          // SAVE TO REST API
          await post(url, {
            data: {
              month: this.form.month,
              position: this.form.position,
              biaya_array: this.form.biaya_array,
              pendapatan_array: this.form.pendapatan_array
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              // if (this.form.id === '') {
              //   this.fetch()
              // } else {
              //   this.fetch(this.paginationList)
              // }
              this.fetchData()
              this.reset()

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`pos/satuan/delete`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch(this.paginationList)
          } else {
            this.message.error = res.message
          }
        })
      }

    }
  }
</script>


<style>
table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
  border-collapse: collapse;
}

.view {
  margin: auto;
  width: 100%;
}

.wrapper-laba-rugi { 
  overflow-y: auto; 
  height: calc(100vh - 260px); 
} 
.wrapper-laba-rugi th { 
  position: sticky; 
  top: 0; 
  background-color: white !important;
} 
.list_hover:hover {background-color: #1976d236;}
.selected {background-color: #1976d236;}

</style>